import * as actionTypes from './actionTypes';

export const resetLogsState = () => {
  return {
    type: actionTypes.RESET_LOGS_STATE,
    
  };
}
export const initLogsStart = () => {
  return {
    type: actionTypes.INIT_LOGS_START
  };
};

export const initLogLinkStart = () => {
  return {
    type: actionTypes.INIT_LOG_LINK_START
  };
};
export const getLogLink = () => {
  return {
    type: actionTypes.GET_LOG_LINK
  };
};
export const refreshLogs = () => {
  return window.location.reload();
};
export const setLogs = (logsList) => {
  return {
    type: actionTypes.SET_LOGS,
    logsList: logsList
  };
};
export const setLogLink = (logsLink) => {
  return {
    type: actionTypes.SET_LOG_LINK,
    logsLink: logsLink
  };
};
export const setActiveLog = (activeLog) => {
  return {
    type: actionTypes.SET_ACTIVE_LOG,
    activeLog: activeLog
  };
};
export const setFromLogDetailsPage = (value) => {
  return {
    type: actionTypes.SET_FROM_LOG_DETAILS_PAGE,
    fromDetailsPage: value
  };
};

export const fetchLogsFailed = () => {
  return {
    type: actionTypes.FETCH_LOGS_FAILED
  };
};
export const fetchLogLinkFailed = () => {
  return {
    type: actionTypes.FETCH_LOG_LINK_FAILED
  };
};

export const initLogs = () => {
  return {
    type: actionTypes.INIT_LOGS
  };
};

export const getOneLog = (id) => {
  return {
    type: actionTypes.GET_ONE_LOG,
    logId: id
  };
};
export const getOneLogStart = () => {
  return {
    type: actionTypes.GET_ONE_LOG_START
  };
};
export const getOneLogFail = error => {
  return {
    type: actionTypes.GET_ONE_LOG_FAIL,
    error: error
  };
};

export const deleteLog = (id) => {
  return {
    type: actionTypes.DELETE_LOGS,
    logId: id
  };
};

export const editLog = (payload) => {
  return {
    type: actionTypes.EDIT_LOGS,
    payload: payload
  };
};
export const editLogSuccess = (payload) => {
  return {
    type: actionTypes.EDIT_LOGS_SUCCESS,
    payload: payload
  };
};
export const editLogStart = () => {
  return {
    type: actionTypes.EDIT_LOGS_START
  };
};
export const editLogFail = error => {
  return {
    type: actionTypes.EDIT_LOGS_FAIL,
    error: error
  };
};

export const addLogSuccess = (consumerkey, formData) => {
  return {
    type: actionTypes.ADD_LOGS_SUCCESS,
    logId: consumerkey,
    formData: formData
  };
};

export const addLogFail = error => {
  return {
    type: actionTypes.ADD_LOGS_FAIL,
    error: error
  };
};

export const addLogStart = () => {
  return {
    type: actionTypes.ADD_LOGS_START
  };
};

export const addLog = (formData) => {
  return {
    type: actionTypes.ADD_LOGS,
    formData: formData
  };
};

export const addLogInit = () => {
  return {
    type: actionTypes.ADD_LOGS_INIT
  };
};
